import React from 'react';

import { cn } from 'revibe-ui';
import { useTranslation } from 'i18n/hooks';

import { Link } from 'ui/components/Link';
import { RightArrowIcon } from 'ui/icons/RightArrowIcon';

interface StarProps {
  className?: string;
}

const Star = ({ className }: StarProps) => (
  <span className="-mt-1 w-fit">
    <svg
      className={cn('inline', className)}
      width="1em"
      height="1em"
      viewBox="0 0 19 17"
      fill="none"
    >
      <path d="M13.088 11.808l1.65 4.776-5.586-3.817 3.936-.96zm5.103-5.213h-6.906L9.153.417l-2.14 6.179-6.906-.008 5.592 3.822-2.14 6.173 5.593-3.817 3.453-2.356 5.586-3.815z"></path>
    </svg>
  </span>
);

const StarHalf = ({ className }: StarProps) => (
  <span className="-mt-1 w-fit">
    <svg
      className={cn('inline', className)}
      width="1em"
      height="1em"
      viewBox="0 0 19 17"
      fill="none"
    >
      <defs>
        <linearGradient id="trustPilotStar-halfFillWhite_svg__a">
          <stop offset="50%" className={className}></stop>
          <stop offset="50%" stopColor="gray"></stop>
        </linearGradient>
      </defs>
      <path
        fill="url(#trustPilotStar-halfFillWhite_svg__a)"
        d="M13.722 11.808l1.65 4.776-5.586-3.817 3.936-.96zm5.103-5.213H11.92L9.787.417l-2.14 6.179-6.906-.008 5.593 3.822-2.14 6.173 5.592-3.817 3.454-2.356 5.585-3.815z"
      ></path>
    </svg>
  </span>
);

interface RatingTrustpilotProps {
  className?: string;
  starClassName?: string;
}

export const RatingTrustpilot = ({
  className,
  starClassName,
}: RatingTrustpilotProps) => {
  const { tu, t } = useTranslation();

  return (
    <div className={cn('w-full text-center font-sans', className)}>
      <div className="mx-auto flex w-fit items-center">
        <Star className={starClassName} />
        <Star className={starClassName} />
        <Star className={starClassName} />
        <Star className={starClassName} />
        <StarHalf className={starClassName} />
      </div>
      <p className="pt-2 font-medium">
        {`4.7 ${t('out-of', 'common')} 5 ${t('stars', 'common')} ${t(
          'on',
          'common'
        )} Trustpilot`}
      </p>
      <Link
        className="text-sm"
        to="https://www.trustpilot.com/review/revibe-upcycling.com"
        target="_blank"
      >
        {tu('read-review', 'common')}{' '}
        <RightArrowIcon className="inline h-3 w-3" />
      </Link>
    </div>
  );
};
